import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Detections' })({
    root: {},
    content: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        background: '#F8F8F8',
        padding: '16px 8px 8px 8px'
    },
    _rounded: {
        borderTopLeftRadius: 16
    },
    collapse: {
        mask: 'linear-gradient(90deg, transparent, white 12px calc(100% - 24px), transparent)'
    },
    configuration: {
        padding: '0 16px 12px 24px'
    }
});
